/**
 * liveFrameCache — carries the last live canvas frame from Live → Playback.
 *
 * Before navigating to /mcplayback, LiveView captures each visible WS tile's
 * canvas as a data URL and stores it here keyed by cameraId. MCPlaybackView
 * reads on mount to show real camera images as initial cell placeholders
 * instead of the Dividia logo. Cleared after first read or on logout.
 */

let _frames = {};

export const setLiveFrame = (cameraId, dataUrl) => {
  _frames[cameraId] = dataUrl;
};

export const getLiveFrame = (cameraId) => _frames[cameraId] || null;

export const getAllLiveFrames = () => ({ ..._frames });

export const clearLiveFrames = () => { _frames = {}; };
